export const GET_DMX_DEVICE_PRESETS = 'GET_DMX_DEVICE_PRESETS';
export const GET_DMX_DEVICE_PRESETS_SUCCESS = 'GET_DMX_DEVICE_PRESETS_SUCCESS';
export const GET_DMX_DEVICE_PRESETS_ERROR = 'GET_DMX_DEVICE_PRESETS_ERROR';
